var map = {
	".": "4RZf",
	"./": "4RZf",
	"./01_error_code": "XCkz",
	"./01_error_code.json": "XCkz",
	"./02_timestamp": "oPkH",
	"./02_timestamp.json": "oPkH",
	"./03_digital_rule": "WihS",
	"./03_digital_rule.json": "WihS",
	"./04_rate_limits": "p+dP",
	"./04_rate_limits.json": "p+dP",
	"./05_system_time": "lC7j",
	"./05_system_time.json": "lC7j",
	"./index": "4RZf",
	"./index.js": "4RZf",
	"./index_share_to_v1": "8rn0",
	"./index_share_to_v1.js": "8rn0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AYyd";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/api/basic ^.*$
// module id = AYyd
// module chunks = 3